import type { OrgType } from "@shared/types/org";

import apiClient from "./axios";

export interface ImpersonationResponse {
  message: string;
  originalUser: {
    email: string;
    id: string;
    username: string;
  };
  success: boolean;
  token: string;
  user: {
    email: string;
    firstName?: string;
    id: string;
    lastName?: string;
    // Nullable: null-org users live on `UserCampaignViewAssignment.organizationId`
    // for firm scope, not `User.organizationId`, so they can be impersonated
    // with no `organization` attached.
    organization: {
      id: string;
      name: string;
      orgType: OrgType;
    } | null;
    roles: Array<{
      description?: string;
      id: string;
      name: string;
    }>;
    username: string;
  };
}

// Impersonation (God Mode) API
export const impersonationApi = {
  // Start impersonating a user
  impersonate: async (userId: string): Promise<ImpersonationResponse> => {
    const response = await apiClient.post(`/admin/superadmin/impersonation/start/${userId}`);
    return response.data;
  },

  // Stop impersonating and return to original user
  stopImpersonation: async (): Promise<{
    message: string;
    success: boolean;
    token: string;
    user: {
      email: string;
      firstName?: string;
      id: string;
      lastName?: string;
      organization: {
        id: string;
        name: string;
        orgType: OrgType;
      } | null;
      roles: Array<{
        description?: string;
        id: string;
        label: string;
        name: string;
      }>;
      username: string;
    };
  }> => {
    const response = await apiClient.post("/admin/superadmin/impersonation/stop");
    return response.data;
  },

  // Check if currently impersonating
  getImpersonationStatus: async (): Promise<{
    impersonationData?: {
      currentUser: {
        email: string;
        id: string;
        username: string;
      };
      originalUserEmail: string;
      originalUserId: string;
      startedAt: string;
    };
    isImpersonating: boolean;
  }> => {
    const response = await apiClient.get("/admin/superadmin/impersonation/status");
    return response.data;
  },
};
